import { Card, Form, Space, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../config/api";
import { POST } from "../utils/apicalls";
import { GrView } from "react-icons/gr";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

function TelecallerIndexDashboard() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5); // Define the page size
  const [data, setData] = useState<any>();
  const user: any = useSelector((state: RootState) => state?.user);
  const [projectdata, setprojectData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [metas, setsMeta] = useState<any>({});
  const [meta, setMeta] = useState<any>({});
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setprojectData(response?.data);

      setsMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);
  const columns = [
    {
      dataIndex: "type",
      title: "type",
    },
    {
      dataIndex: "enquery_name",
      title: "enquery_name",
    },
    {
      dataIndex: "date",
      title: "date",
      render: (date: any) => (date ? moment(date).format("YYYY-DD-MM") : "-"),
    },
    {
      dataIndex: "feedback",
      title: "feedback",
    },
    {
      dataIndex: "enquery_phone",
      title: "enquery_phone",
    },
    {
      title: "wrokUpdate",
      dataIndex: "wrokUpdate",
      render: (wrokUpdate: any) => {
        let color = "";

        // Assign colors based on the wrokUpdate value
        switch (wrokUpdate?.toLowerCase()) {
          case "completed":
            color = "green";
            break;
          case "pending":
            color = "red";
            break;
          case "inProgress":
            color = "orange";
            break;
          default:
            color = ""; // Default color
        }
        return <span style={{ color, fontWeight: "bold" }}>{wrokUpdate}</span>;
      },
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() =>
              navigate(`/Telecaller/TelecallerWrokUpdate_details/${record?.id}`)
            }
          />
        </Space>
      ),
    },
  ];

  const fetchVisitors = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 10,
        employeeId: user.id,
      };
      const url = API.LIST_TELECALLER;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchVisitors(page, pageSize);
  }, [page, pageSize]);
  return (
    <>
      <div>
        {" "}
        <Card onClick={() => navigate("/Telecaller/Project_Details")}>
          <h2 style={{ textAlign: "center" }}>
            Total Projects: {metas?.total_count}
          </h2>
          <div className="grid-container">
            {/* Completed Projects */}
            <Card className="inner-card">
              <h6>Completed</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) =>
                    project.status === "completed"
                ).length
              }
            </Card>

            {/* Pending Projects */}
            <Card className="inner-card">
              <h6>Pending</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) => project.status === "pending"
                ).length
              }
            </Card>

            {/* Running Projects */}
            <Card className="inner-card">
              <h6>Running</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) => project.status === "running"
                ).length
              }
            </Card>

            {/* In Progress Projects */}
            <Card className="inner-card">
              <h6>In Progress</h6>

              {
                projectdata?.filter(
                  (project: { status: string }) =>
                    project.status === "in-progress"
                ).length
              }
            </Card>
          </div>
        </Card>
      </div>
      <div>
        <Card>
          <h2 style={{ textAlign: "center" }}> wrok details</h2>
          <Card>
            <Table columns={columns} dataSource={data} />
          </Card>
        </Card>
      </div>
    </>
  );
}

export default TelecallerIndexDashboard;
